import { RouterConfiguration, RouterConfigurationParameters } from '@generated/router';

import { ContentConfiguration, ContentConfigurationParameters } from '@generated/content';

export function contentApiConfigFactory(): ContentConfiguration {
  const params: ContentConfigurationParameters = { withCredentials: true };
  return new ContentConfiguration(params);
}

export function routerApiConfigFactory(): RouterConfiguration {
  const params: RouterConfigurationParameters = { withCredentials: true };
  return new RouterConfiguration(params);
}
